module.exports = __webpack_public_path__ + "img/newMh.b7ca7e78.svg";